import { render, staticRenderFns } from "./RiskAreaDetail.vue?vue&type=template&id=7bba4bbd&scoped=true"
import script from "./RiskAreaDetail.vue?vue&type=script&lang=js"
export * from "./RiskAreaDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskAreaDetail.vue?vue&type=style&index=0&id=7bba4bbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba4bbd",
  null
  
)

export default component.exports